import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetEmailToVerifyMutationVariables = Types.Exact<{
  input: Types.ResetEmailToVerifyInput;
}>;


export type ResetEmailToVerifyMutation = { __typename?: 'RootMutationType', resetEmailToVerify?: { __typename?: 'AuthResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const ResetEmailToVerifyDocument = gql`
    mutation resetEmailToVerify($input: ResetEmailToVerifyInput!) {
  resetEmailToVerify(input: $input) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type ResetEmailToVerifyMutationFn = Apollo.MutationFunction<ResetEmailToVerifyMutation, ResetEmailToVerifyMutationVariables>;

/**
 * __useResetEmailToVerifyMutation__
 *
 * To run a mutation, you first call `useResetEmailToVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEmailToVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEmailToVerifyMutation, { data, loading, error }] = useResetEmailToVerifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetEmailToVerifyMutation(baseOptions?: Apollo.MutationHookOptions<ResetEmailToVerifyMutation, ResetEmailToVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEmailToVerifyMutation, ResetEmailToVerifyMutationVariables>(ResetEmailToVerifyDocument, options);
      }
export type ResetEmailToVerifyMutationHookResult = ReturnType<typeof useResetEmailToVerifyMutation>;
export type ResetEmailToVerifyMutationResult = Apollo.MutationResult<ResetEmailToVerifyMutation>;
export type ResetEmailToVerifyMutationOptions = Apollo.BaseMutationOptions<ResetEmailToVerifyMutation, ResetEmailToVerifyMutationVariables>;